import { render, staticRenderFns } from "./TemplateItems.vue?vue&type=template&id=6aba3bd0&scoped=true&"
import script from "./TemplateItems.vue?vue&type=script&lang=js&"
export * from "./TemplateItems.vue?vue&type=script&lang=js&"
import style0 from "./TemplateItems.vue?vue&type=style&index=0&id=6aba3bd0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aba3bd0",
  null
  
)

export default component.exports